const routes = [
    // 外教规则设置路由
    {
      path: "/foreignRules",
      name: "foreignRules",
      meta: {
        title: "规则设置",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignRules/index.vue")
    },
  ];
  export default routes;